var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "headline indigo darken-4 white--text fixed-header",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.contractNotes').toUpperCase()) + "\n      ")]), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.notes) + "\n      ")]), _c('v-divider'), _c('v-card-text', {
    staticClass: "font-italic text-xs-center title font-weight-regular"
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.confirmContractNotes')) + "\n      ")]), _c('div', {
    staticClass: "footer text-xs-center mb-3"
  }, [_c('v-divider'), _c('v-card-text', [_c('v-btn', {
    on: {
      "click": function click($event) {
        return _vm.back();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.back')) + "\n          ")]), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.confirmContractNotes();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.proceedToTheNextSection')) + "\n          ")]), _c('abort-visit', {
    on: {
      "aborted": function aborted($event) {
        return _vm.visitAborted();
      }
    }
  })], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }